// components/ProtectedLayout.js
import React from "react";
import useAutoLogout from "./Utils/AutoLogout";

const ProtectedLayout = ({ children }) => {
  useAutoLogout(3600000); // 1 hour inactivity

  return <>{children}</>;
};

export default ProtectedLayout;
